import { render, staticRenderFns } from "./begin-end-block.vue?vue&type=template&id=03fc3da6&"
import script from "./begin-end-block.vue?vue&type=script&lang=js&"
export * from "./begin-end-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports